<template>
  <div class="wrap-404">
    404
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.wrap-404 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: calc(100vh - 56px);
}
</style>
